import Base from './base'
import Request from '@utils/request'
import { toQueryString } from '@utils'

class Task extends Base {
  async getTask(id, params = {}) {
    const url = `/api/tasks/${id}?${toQueryString(params)}`
    const response = await Request.get(url)

    return response
  }

  async complete(id, data) {
    const url = `/api/tasks/${id}/complete`
    const response = await Request.post(url, data)

    return response
  }

  async managerReview(id, data) {
    const url = `/api/tasks/${id}/review`
    const response = await Request.put(url, data)

    return response
  }

  async destroy(id) {
    const url = `/api/tasks/${id}`
    const response = await Request.delete(url)

    return response
  }
}

export default new Task()
